import { PaginatedReturnImportListReadable, StepEnum } from '@crm/api'
import { useStyles } from '@crm/features/leads/styles'
import { usePaginationConfigCrm } from '@crm/hooks'
import { ConditionalText } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Col, List, Progress, Row, Tooltip } from 'antd'

import { ConditionalLink } from './ConditionalLink'

type Props = {
  item?: PaginatedReturnImportListReadable
}

export const ImportInfo = ({ item }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const { params, updateQuery } = useQueryUpdate()

  return (
    <List
      dataSource={item?.results}
      itemLayout="vertical"
      pagination={{
        ...usePaginationConfigCrm(item),
        position: 'bottom',
        onChange: (page: number, pageSize: number) =>
          updateQuery({
            ...params,
            page: page.toString(),
            per_page: pageSize.toString()
          })
      }}
      renderItem={(item) => (
        <ConditionalLink
          condition={item?.step !== StepEnum.COMPLETED}
          path={`/leads/import/${item?.id}/${item?.step}`}
        >
          <List.Item className={styles.list} style={{ padding: '12px' }}>
            <Row align="middle">
              <Col span={2}>{item?.id}</Col>

              <Col span={4}>
                <ConditionalText condition={!!item?.tag?.name}>
                  {item?.tag?.name}
                </ConditionalText>
              </Col>

              <Col span={6}>
                <ConditionalText condition={!!item?.owner?.email}>
                  {item?.owner?.email}
                </ConditionalText>
              </Col>

              <Col span={4}>
                <Tooltip
                  placement="top"
                  trigger="hover"
                  title={t(
                    `import.${
                      item?.step === StepEnum.COMPLETED
                        ? item?.status
                        : item?.step
                    }`
                  )}
                >
                  {t(
                    `import.${
                      item?.step === StepEnum.COMPLETED
                        ? item?.status
                        : item?.step
                    }`
                  )}
                </Tooltip>
              </Col>

              <Col span={8}>
                <Progress percent={item?.progress} />
              </Col>
            </Row>
          </List.Item>
        </ConditionalLink>
      )}
    />
  )
}
